import { ANIMATIONS_STYLES } from '../commons/foundations/animations';
import { BREAKPOINTS } from '../commons/foundations/breakpoints';
import { FOCUS_STYLES as FOCUS_COMMON_STYLES } from '../commons/foundations/focusStyles';
import { ICONS_STYLES } from '../commons/foundations/icons';
import { ILLUSTRATIONS_STYLES } from '../commons/foundations/illustrations';
import { MEDIA_QUERIES } from '../commons/foundations/mediaQueries';
import { FONT_WEIGHT, TEXT_ALIGN } from '../commons/foundations/typography';
import { Z_INDEX } from '../commons/foundations/zIndex';
import { getBlur } from '../config/blur';
import { RELOADED_COBRANDED_GLOBAL_STYLES } from '../config/cobranded/globalStyles/globalStyles';
import { FONT_FAMILY, getTextStyles } from '../config/cobranded/text';
import { DEGREES } from '../config/degrees';
import { getFont } from '../config/font';
import { getGradient } from '../config/gradient';
import { getShadow } from '../config/shadow';
import { cobrandedLightRegular as FOUNDATIONS_STYLES } from './cobrandedLightRegular';
const SHADOWS = getShadow(FOUNDATIONS_STYLES);
const FONT_STYLES = getFont(FOUNDATIONS_STYLES);
const TEXT_STYLES = getTextStyles(FONT_STYLES);
const BLUR = getBlur(FOUNDATIONS_STYLES);
const GRADIENTS = getGradient(FOUNDATIONS_STYLES);
const FOCUS_STYLES = FOCUS_COMMON_STYLES(FOUNDATIONS_STYLES);
export const COBRANDED_LIGHT_REGULAR_BASE_STYLES = {
    ...FOUNDATIONS_STYLES,
    ...SHADOWS,
    ...BLUR,
    ...GRADIENTS,
    ...DEGREES,
    TEXT_STYLES,
    FONT_FAMILY,
    FONT_STYLES,
    MEDIA_QUERIES,
    BREAKPOINTS,
    TEXT_ALIGN,
    FONT_WEIGHT,
    Z_INDEX,
    ICONS_STYLES,
    ILLUSTRATIONS_STYLES,
    ANIMATIONS_STYLES,
    FOCUS_STYLES,
};
export const COBRANDED_LIGHT_REGULAR_GLOBAL_STYLES = RELOADED_COBRANDED_GLOBAL_STYLES(FOUNDATIONS_STYLES);
export const COBRANDED_LIGHT_REGULAR_GLOBAL_STYLES_ELEMENT_CONTAINER = (elementContainer) => RELOADED_COBRANDED_GLOBAL_STYLES(FOUNDATIONS_STYLES, elementContainer);
//# sourceMappingURL=baseStyles.js.map